import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Hook to fetch all historical VGC formats from Smogon stats.
 * Results are cached on the backend for 7 days.
 */
const useVgcFormats = () => {
  const [formats, setFormats] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchFormats = async () => {
      try {
        const response = await axios.get('/api/vgc-formats');
        setFormats(response.data || []);
      } catch (err) {
        console.error('Error fetching VGC formats:', err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFormats();
  }, []);

  return { formats, loading, error };
};

export default useVgcFormats;
